const UNIT_TO_OZ: Record<string, number> = {
  OZ: 1,
  L: 33.814,
  ML: 0.033814,
  G: 128,
}

export function getVolumeOz(
  size?: number | null,
  unit?: string | null,
): number | null {
  if (!size || !unit) return null
  const factor = UNIT_TO_OZ[unit.toUpperCase()]
  if (!factor) return null
  return size * factor
}

export type PlanogramImageStyleHint = {
  scale?: number
  scaleX?: number
  scaleY?: number
  objectPosition?: string
}

export const WIDE_ASPECT_TRIGGER = 0.5
export const VERY_WIDE_TRIGGER = 0.65
export const MAX_SCALE = 1.6
export const DEFAULT_SCALE = 1

export const PLANOGRAM_IMAGE_OVERRIDES: Record<
  string,
  PlanogramImageStyleHint
> = {}

const clampScale = (scale: number) =>
  Math.max(DEFAULT_SCALE, Math.min(MAX_SCALE, scale))

export const getHeuristicPlanogramImageStyle = (params: {
  upc: string
  naturalWidth?: number | null
  naturalHeight?: number | null
}): PlanogramImageStyleHint => {
  const { upc, naturalWidth, naturalHeight } = params

  if (PLANOGRAM_IMAGE_OVERRIDES[upc]) {
    return PLANOGRAM_IMAGE_OVERRIDES[upc]
  }

  if (!naturalWidth || !naturalHeight || naturalHeight <= 0) {
    return { scale: DEFAULT_SCALE }
  }

  const aspectRatio = naturalWidth / naturalHeight

  if (aspectRatio >= VERY_WIDE_TRIGGER) {
    return { scale: clampScale(1.35) }
  }

  if (aspectRatio >= WIDE_ASPECT_TRIGGER) {
    return { scale: clampScale(1.2) }
  }

  return { scale: DEFAULT_SCALE }
}
